import { useState } from "react";
import { addDoc, collection, serverTimestamp, updateDoc, doc } from "firebase/firestore";
import { db, storage } from "../../firebaseConfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import toast, { Toaster } from "react-hot-toast";

export default function AdminLegalUpload() {
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [type, setType] = useState("ACT");
  const [language, setLanguage] = useState("EN");
  const [year, setYear] = useState("2023");
  const [tags, setTags] = useState("election, membership, audit");
  const [access, setAccess] = useState("public");
  const [loading, setLoading] = useState(false);

  const upload = async () => {
    if (!file || !title.trim()) return toast.error("PDF and Title required");
    setLoading(true);
    try {
      const docRef = await addDoc(collection(db, "legal_docs"), {
        title,
        type,
        language,
        year: year || "",
        tags: String(tags || "").split(",").map((s) => s.trim()).filter(Boolean),
        access,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        pdfUrl: "",
        pageCount: 0,
      });

      const path = `legal_docs/${docRef.id}.pdf`;
      const sref = ref(storage, path);
      await uploadBytes(sref, file);
      const pdfUrl = await getDownloadURL(sref);

      // ✅ FIX: update same legal_docs document (no extra collection write)
      await updateDoc(doc(db, "legal_docs", docRef.id), {
        pdfUrl,
        updatedAt: serverTimestamp(),
      });

      toast.success("Uploaded. Now run extraction (Phase-2) to enable search/Q&A.");
    } catch (e) {
      console.error(e.show || e);
      toast.error("Upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 p-6">
      <Toaster />
      <div className="max-w-3xl mx-auto bg-white rounded-2xl border shadow-sm p-6 space-y-4">
        <div>
          <div className="text-xs uppercase tracking-widest text-emerald-600 font-extrabold">Admin</div>
          <div className="text-2xl font-extrabold">Upload Legal Document (PDF)</div>
        </div>

        <input
          type="file"
          accept="application/pdf"
          onChange={(e) => setFile(e.target.files?.[0] || null)}
        />

        <input
          className="w-full border rounded-xl px-3 py-2"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Title"
        />

        <div className="grid md:grid-cols-3 gap-2">
          <select
            className="border rounded-xl px-3 py-2"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="ACT">Act</option>
            <option value="RULES">Rules</option>
            <option value="BYLAWS">Bye-laws</option>
            <option value="FORM">Forms</option>
          </select>

          <select
            className="border rounded-xl px-3 py-2"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
          >
            <option value="EN">English</option>
            <option value="HI">Hindi</option>
            <option value="GU">Gujarati</option>
          </select>

          <input
            className="border rounded-xl px-3 py-2"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            placeholder="Year"
          />
        </div>

        <input
          className="w-full border rounded-xl px-3 py-2"
          value={tags}
          onChange={(e) => setTags(e.target.value)}
          placeholder="tags: election, audit, board..."
        />

        <select
          className="border rounded-xl px-3 py-2"
          value={access}
          onChange={(e) => setAccess(e.target.value)}
        >
          <option value="public">Public</option>
          <option value="members">Members Only</option>
        </select>

        <button
          onClick={upload}
          disabled={loading}
          className="w-full px-4 py-3 rounded-xl bg-slate-900 text-white font-extrabold disabled:opacity-60"
        >
          {loading ? "Uploading…" : "Upload PDF"}
        </button>

        <div className="text-xs text-slate-600 bg-slate-50 border rounded-xl p-3">
          Note: Upload ke baad search/Q&A enable karne ke liye extraction step (Phase-2) run karna hota hai.
        </div>
      </div>
    </div>
  );
}
